import PropTypes from "prop-types"
import { SEARCH_KIND } from "components/admin/FilterBar/FilterInput"
import { Box, Button } from "@planningcenter/tapestry-react"
import { css } from "@emotion/core"

const FilterBadges = ({
  searches,
  filterOptions,
  filterMenuItems,
  onRemove,
  onClear,
  children
}) => {
  const searchItems = Object.values(searches).filter(s => s.kind !== SEARCH_KIND)

  return (
    <div className="p-r p-1 pr-4">
      <div className="d-f ai-fs fw-w" style={{ gap: "0.5rem", flex: 1 }}>
        {Object.entries(searches).map(
          ([key, search]) =>
            filterMenuItems[search.kind] && (
              <Button
                key={key}
                size="xs"
                theme="filterBar"
                onClick={() => onRemove(key)}
                iconRight={{
                  name: "general.x",
                  size: "8px",
                  color: "var(--color--brand-43)"
                }}
                title={filterMenuItems[search.kind].badge(search, filterOptions[search.kind])}
              />
            )
        )}
        {children}
      </div>
      {searchItems.length > 0 && (
        <Box css={clearFilterIcon}>
          <Button
            icon={{ name: "general.x" }}
            onClick={() => onClear()}
            title="Clear current filters"
            size="md"
            theme="naked"
          />
        </Box>
      )}
    </div>
  )
}

const clearFilterIcon = css`
  cursor: pointer;
  color: var(--t-fill-color-neutral-040);
  font-size: 14px;
  position: absolute;
  right: 8px;
  top: 2px;
`

FilterBadges.propTypes = {
  searches: PropTypes.shape({}),
  filterOptions: PropTypes.shape({}),
  filterMenuItems: PropTypes.shape({}),
  onRemove: PropTypes.func,
  onClear: PropTypes.func,
  children: PropTypes.node
}

export default FilterBadges
